import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface TimelineMemoriesSectionProps {
  language: 'en' | 'mr';
}

const memories = [
  {
    year: '0',
    title: 'The Beginning',
    titleMr: 'सुरुवात',
    description: 'When two hearts became one',
    descriptionMr: 'जेव्हा दोन हृदय एक झाले',
    icon: '💑',
  },
  {
    year: '1',
    title: 'First Year',
    titleMr: 'पहिले वर्ष',
    description: 'Building dreams together',
    descriptionMr: 'एकत्र स्वप्न बांधणे',
    icon: '🌹',
  },
  {
    year: '2',
    title: 'Growing Stronger',
    titleMr: 'अधिक मजबूत होणे',
    description: 'Love deepens with each moment',
    descriptionMr: 'प्रत्येक क्षणे प्रेम गहिरे होते',
    icon: '💎',
  },
  {
    year: '3',
    title: 'Precious Moments',
    titleMr: 'मूल्यवान क्षण',
    description: 'Creating everlasting memories',
    descriptionMr: 'शाश्वत स्मृती निर्माण करणे',
    icon: '✨',
  },
  {
    year: '5+',
    title: 'Eternal Love',
    titleMr: 'शाश्वत प्रेम',
    description: 'A love story for the ages',
    descriptionMr: 'सर्व काळासाठी एक प्रेम कहाणी',
    icon: '👑',
  },
];

export const TimelineMemoriesSection: React.FC<TimelineMemoriesSectionProps> = ({ language }) => {
  const [currentIdx, setCurrentIdx] = useState(0);

  const handlePrev = () => {
    setCurrentIdx((prev) => (prev - 1 + memories.length) % memories.length);
  };

  const handleNext = () => {
    setCurrentIdx((prev) => (prev + 1) % memories.length);
  };

  const current = memories[currentIdx];

  return (
    <section className="relative py-24 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-center text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-rose-400 mb-16">
          {language === 'mr' ? '📜 आमच्या स्मृती' : '📜 Our Memories'}
        </h2>

        <div className="bg-white/5 backdrop-blur-md rounded-3xl border-2 border-amber-400/30 p-12 shadow-2xl">
          <div className="text-center mb-8">
            <div className="text-7xl mb-4">{current.icon}</div>
            <div className="text-amber-300 text-lg font-bold mb-2">
              {language === 'mr' ? 'वर्ष' : 'Year'} {current.year}
            </div>
            <h3 className="text-4xl font-black text-amber-100 mb-3">
              {language === 'mr' ? current.titleMr : current.title}
            </h3>
            <p className="text-lg text-rose-200 font-serif italic">
              {language === 'mr' ? current.descriptionMr : current.description}
            </p>
          </div>

          <div className="flex justify-center gap-6 mt-8">
            <button
              onClick={handlePrev}
              className="p-3 rounded-full bg-gradient-to-r from-amber-500 to-rose-500 text-white hover:shadow-lg hover:shadow-amber-500/50 transition-all transform hover:scale-110"
            >
              <ChevronLeft size={24} />
            </button>
            <button
              onClick={handleNext}
              className="p-3 rounded-full bg-gradient-to-r from-rose-500 to-amber-500 text-white hover:shadow-lg hover:shadow-rose-500/50 transition-all transform hover:scale-110"
            >
              <ChevronRight size={24} />
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {memories.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentIdx(idx)}
                className={`h-3 rounded-full transition-all ${
                  idx === currentIdx
                    ? 'bg-gradient-to-r from-amber-400 to-rose-400 w-8'
                    : 'bg-gray-500 w-3 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
